import { useLazyQuery } from '@apollo/client/react';
import type { FC, ReactNode } from 'react';

import { AsyncSelect } from '@zen/DesignSystem';
import type { Nullable } from '@zen/utils/typescript';

import { TerminalOptionsDocument, type TerminalOptionsQueryResult, type TerminalOptionsQueryVariables } from './graphql';
import type { Terminal, TransportTerminal } from './types';

interface Props {
  hasError?: boolean;
  isClearable?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  name: string;
  onBlur?: () => void;
  onChange?: (terminal: Nullable<Terminal>) => void;
  placeholder?: string;
  renderMenuInPortal?: boolean;
  value: Nullable<Terminal>;
  variant?: 'default' | 'inline';
  withGroups?: boolean;
}

const TerminalSelect: FC<Props> = (props) => {
  const [fetchTerminals] = useLazyQuery<TerminalOptionsQueryResult, TerminalOptionsQueryVariables>(TerminalOptionsDocument);

  const handleInputChange = async (query: string): Promise<Terminal[]> => {
    const response = await fetchTerminals({ variables: { query } });
    const terminals: TransportTerminal[] = response?.data?.transportTerminals?.nodes || [];

    return [...terminals];
  };

  const formatLabel = (terminal: Terminal): ReactNode => {
    return terminal.label;
  };

  return <AsyncSelect<Terminal> {...props} formatOptionLabel={formatLabel} loadOptions={handleInputChange} />;
};

export type { Props as TerminalSelectProps };

export default TerminalSelect;
